import { Button, Card, Col, Typography } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from 'swiper/modules';
import Calendar from 'react-calendar';
import dayjs from 'dayjs';
import { useState } from "react";
import 'react-calendar/dist/Calendar.css';
import '../../styles/pages/calendar/CalendarStyles.css'
import { useSelector } from "react-redux";

interface CalendarWithSwiperProps {
    selectedDate: dayjs.Dayjs;
    setSelectedDate: (date: dayjs.Dayjs) => void;
}

const { Title, Text } = Typography;
const events = [
    {
        title: 'Pythons Unleashed: A Development Expedition dsdasdsdsdsdasdsdsdasdasdasdasdasdasdasdsdsadasdasdasdasdsada',
        date: dayjs('2025-04-15'),
        time: '12:00 PM - 6:00 PM',
    },
    {
        title: 'Pythons Unleashed: A Development Expedition',
        date: dayjs('2025-04-15'),
        time: '12:00 PM - 6:00 PM',
    },
    {
        title: 'Pythons Unleashed: A Development Expedition',
        date: dayjs('2025-04-15'),
        time: '12:00 PM - 6:00 PM',
    },
    {
        title: 'Pythons Unleashed: A Development Expedition',
        date: dayjs('2025-04-15'),
        time: '12:00 PM - 6:00 PM',
    },
];


const CalendarWithSwiper: React.FC<CalendarWithSwiperProps> = ({
    selectedDate,
    setSelectedDate
}) => {
    /*
    const {
        rex_citas_next7
    } = useSelector(({ citas }: { citas: AgendaCitasState }) => citas)
     */

    //console.log('rex_citas_next7:', rex_citas_next7)

    return (
        <div className="bg-white">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: '20px', marginBottom: '16px' }}>
                    Calendario
                </Title>
            </div>
            <Col span={24}>

                <Calendar
                  //  onChange={(date: Date) => setSelectedDate(dayjs(date))}
                    value={selectedDate.toDate()}
                />

            </Col>

            {/* <Col span={24} style={{ marginTop: 24 }}>
                <Title
                    level={4}
                    style={{
                        fontSize: '14px',
                        fontWeight: 550,
                        fontFamily: '"Inter", sans-serif',
                        color: '#64748B',
                        marginBottom: '16px',
                        marginTop: '0',
                        marginLeft: '10px'

                    }}
                >
                    Proximos Eventos:
                </Title>

                <div className="absolute top-0 right-4 z-10 flex items-center justify-end h-6">
                    <div className="swiper-pagination-custom"></div>
                </div>
                <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={20}
                    slidesPerView="auto"
                    slidesPerGroup={1}
                    pagination={{
                        clickable: true,
                        el: '.swiper-pagination-custom',
                    }}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    loop={true}
                    style={{ paddingBottom: 40 }}
                >
                    {events.map((event, index) => (
                        <SwiperSlide key={index} style={{ width: 480 }}>
                            <div
                                style={{
                                    height: 100,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    width: '100%',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span
                                        style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '30%',
                                            backgroundColor: '#605DFF',
                                            marginRight: '8px',
                                            marginBottom: '4px'
                                        }}
                                    ></span>
                                    <span
                                        style={{
                                            fontWeight: 'bold',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'clip',
                                            width: '100%',
                                        }}
                                    >
                                        {event.title}
                                    </span>
                                </div>
                                <p style={{ fontSize: '12px', color: '#8c8c8c', margin: 0 }}>
                                    {dayjs(event.date).format('DD [de] MMMM [del] YYYY')}
                                </p>
                                <p style={{ fontSize: '14px', margin: 0 }}>{event.time}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div style={{ textAlign: 'right' }}>
                    <Button type="primary"
                        ghost
                        style={{
                            fontWeight: 'bold',
                            marginTop: '-24px',
                            marginBottom: '24px',
                            marginRight: '24px'
                        }}>
                        + Agregar Nuevo Evento
                    </Button>
                </div>

            </Col> */}
        </div >

    )
}

export default CalendarWithSwiper;